var React = require('react');

function IcLeftComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"<","fillRule":"evenodd","clipRule":"evenodd","d":"M0.49999 8C0.49999 8.26562 0.609365 8.51562 0.796865 8.70312L7.79687 15.7031C7.98437 15.8906 8.23437 16 8.5 16C9.04687 16 9.5 15.5469 9.5 15L9.5 1C9.5 0.453125 9.04687 0 8.5 0C8.23437 0 7.98437 0.109375 7.79687 0.296875L0.796865 7.29687C0.609365 7.48437 0.49999 7.73437 0.49999 8Z","fill":"#9C9C9C"}));
}

IcLeftComponent.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = IcLeftComponent;

IcLeftComponent.default = IcLeftComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/PaginationV2/ic-left.component.svg
// module id = 1643
// module chunks = 0